export default "__VITE_ASSET__1172300d__"